import { TmBaseError } from '@/core/error/tmBaseError'

export class TmUnexpectedErrorTypeError extends TmBaseError {
  public name = 'TmUnexpectedErrorTypeError'

  constructor(e: unknown) {
    super(`Unexpected error type: ${JSON.stringify(e)}`, { error: e })
  }
}
